<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12" :class="[`${prefix}-icon`, `${prefix}-icon-Fire`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_94251d3241__a"><rect width="12" height="12" rx="0"/></clipPath></defs><g clip-path="url(#svg_94251d3241__a)"><path d="M9.814599609375,6.88984375C9.814599609375,6.37384375,9.534099609375,5.23534375,8.923599609375,4.08484375C8.913099609375,4.47034375,8.601099609375,5.40184375,8.371599609375,5.65084375C8.218599609375,5.2158437499999994,8.179599609375,2.31634375,4.354599609375001,1.33984375C4.5870996093750005,4.22434375,1.714599609375,4.182343749999999,1.714599609375,7.29484375C1.714599609375,9.01684375,2.787099609375,10.48684375,4.300599609375,11.07484375C3.817599609375,9.56584375,4.572099609375,8.03134375,5.967099609375,6.63934375C6.213099609375,8.48434375,7.534599609375,8.997343749999999,7.518099609375,10.94584375C8.980599609375,10.22734375,9.937599609375,8.63584375,9.814599609375,6.88984375Z" :fill="useCurrentColor ? 'currentColor' : '#F53F3F'"/></g></svg>
</template>
<script>

export default {
  name: 'IconFire',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
